module.exports = __webpack_public_path__ + "img/44.734da2c0.png";